'use strict';

var quickView = {};

quickView.elementHolder = document.querySelector('.quick-view-holder');
quickView.elementWrapper = document.querySelector('.quick-view-wrapper');
quickView.element = document.querySelector('.quick-view');
quickView.expander = document.querySelector('.quick-view-toggle');

quickView.handler = function() {
    //quickView.expander.addEventListener('click', quickView.expandHandler);
    //quickView.scrollHandler();
};

quickView.expandHandler = function(e) {
    if(quickView.elementWrapper.classList.contains('-expanded')) {
        quickView.elementWrapper.classList.remove('-expanded');
        quickView.expander.innerText = "Expand";
    } else {
        quickView.elementWrapper.classList.add('-expanded');
        quickView.expander.innerText = "Close";
    }
};

function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();

    return rect.bottom > 0 &&
        rect.right > 0 &&
        rect.left < (window.innerWidth || document.documentElement.clientWidth) &&
        rect.top < (window.innerHeight || document.documentElement.clientHeight);
}

quickView.checkVisibility = function() {
    if(isElementInViewport(quickView.elementHolder)) {
        quickView.elementWrapper.classList.remove('-fixed');
    } else {
        quickView.elementWrapper.classList.add('-fixed');
    }
};

quickView.scrollHandler = function() {
    var lastScrollY = 0;
    var ticking = false;

    var update = function () {
        quickView.checkVisibility();
        quickView.elementWrapper.classList.remove('-expanded');
        quickView.expander.innerText = "Expand";
        ticking = false;
    };

    var requestTick = function () {
        if (!ticking) {
            window.requestAnimationFrame(update);
            ticking = true;
        }
    };

    var onScroll = function () {
        lastScrollY = window.scrollY;
        requestTick();
    };

    window.addEventListener('scroll', onScroll);
};


if(quickView.elementWrapper) quickView.handler();